import { render, staticRenderFns } from "./MyGallery.vue?vue&type=template&id=3ed2baba&scoped=true&"
import script from "./MyGallery.vue?vue&type=script&lang=js&"
export * from "./MyGallery.vue?vue&type=script&lang=js&"
import style0 from "./MyGallery.vue?vue&type=style&index=0&id=3ed2baba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2baba",
  null
  
)

export default component.exports